import { getAppStage } from './utils';

export const enableABTestingPOC = () => {
  const stage = getAppStage();
  if (stage === 'Gamma') {
    return true;
  }
  return false;
};
